/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';

/**
 * CheckoutModulesStateShare Input Action
 */

export class CheckoutModulesStateShareInput implements IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `checkoutModulesSharedState`;
    public getCacheObjectType = () => 'checkoutModulesSharedState';
    public dataCacheType = (): CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ICheckoutModulesSharedState {
    invalidAddressForCartProducts?: boolean; // Used to display msg in delivery section
    notBtPostCode?: boolean; // Used to display msg in shipping address section
    isFirstAddress?: boolean; // Check if it is guest checkout or if loggedIn user enters address for the first time and doesn't have any saved address
    loggedInUserNewAddress?: boolean; // Check if it is loggedIn user and tries to add NEW address for second or onwards time, dont disbale shipping address buttom but delivery options if there is restriction case
    isChargesUpdated?: boolean; // Check if the delivery charges have been updated on checkout (to be used in checkout order summary, shipping address, billing address modules)
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new CheckoutModulesStateShareInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function sampleStateAction(input: CheckoutModulesStateShareInput, ctx: IActionContext): Promise<ICheckoutModulesSharedState> {
    return {
        invalidAddressForCartProducts: undefined,
        notBtPostCode: undefined,
        isFirstAddress: undefined,
        loggedInUserNewAddress: undefined,
        isChargesUpdated: undefined
    };
}

/**
 * SampleState - create action
 */
export default createObservableDataAction<ICheckoutModulesSharedState>({
    action: <IAction<ICheckoutModulesSharedState>>sampleStateAction,
    input: createInput
});
